// extracted by mini-css-extract-plugin
export default {"root":"wjRdowR","root_content":"KkA7wrt","root_fullscreen":"+vepI1r","container":"ffwEI6T","header":"_2gX6z0w","action":"_4zubTWw"};